function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("circle", {
  opacity: 0.1,
  cx: 18,
  cy: 18.5,
  r: 18,
  fill: "#758596"
}), React.createElement("path", {
  d: "M26.6933 20.8294C26.1544 22.8406 24.9348 24.6028 23.2423 25.8156C21.5498 27.0285 19.4891 27.6169 17.4114 27.4807C15.3336 27.3445 13.3674 26.4922 11.8477 25.0688C10.3279 23.6454 9.34878 21.7391 9.077 19.6747C8.80521 17.6104 9.25764 15.5156 10.3572 13.7474C11.4567 11.9792 13.1353 10.6469 15.107 9.97763C17.0787 9.30833 19.2215 9.34339 21.1702 10.0768C23.119 10.8103 24.7531 12.1968 25.7942 14",
  stroke: "#758596",
  strokeWidth: 2,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M27.5 10V16C27.5 16 24 16 21.5 16",
  stroke: "#758596",
  strokeWidth: 2,
  strokeLinecap: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 36,
  height: 36,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgRefreshIcon = function SvgRefreshIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRefreshIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh_icon.1779e8a0.svg";
export { ForwardRef as ReactComponent };